module.exports = __webpack_public_path__ + "img/hydration.1c85f30a.svg";